import { useCallback, useEffect, useState } from 'react';

import queryString from 'query-string';
import { Spinner } from '@comeon/ui';
import { useLocation } from 'react-router-dom';

import useCheckLimits from '~/components/limits/hooks/use-check-limits';
import useSuspendedPlayerCheck from '~/components/payment/suspended-players-modal/hook/useSuspendedPlayerCheck';

import QuickDepositMobile from './quick-deposit-mobile';
import LimitsModal from '~/components/limits/modal';
import SuspendedPlayerModal from '~/components/payment/suspended-players-modal';

const QuickDeposit = props => {
	const location = useLocation();
	const { check: checkLimits } = useCheckLimits();
	const { check: checkSuspension } = useSuspendedPlayerCheck();
	const [limitModal, showLimitModal] = useState(false);
	const [suspendedPlayerModal, showSuspendedPlayerModal] = useState(false);
	const queryParams = queryString.parse(location.search);
	const skipDepositValidationOnResult = !!queryParams?.accHistRef;
	const [limitsResolved, setLimitStatus] = useState(skipDepositValidationOnResult);

	const handleDepositValidations = useCallback(async () => {
		// First check for suspension
		const canProceedAfterSuspensionCheck = await checkSuspension();

		if (!canProceedAfterSuspensionCheck) {
			showSuspendedPlayerModal(true);
		}

		// Then check limits
		const proceedWithDeposit = await checkLimits();

		if (!proceedWithDeposit) {
			showLimitModal(true);
		}
		setLimitStatus(true);
	}, [checkLimits, checkSuspension]);

	useEffect(() => {
		if (!skipDepositValidationOnResult) {
			handleDepositValidations();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (suspendedPlayerModal) {
		return <SuspendedPlayerModal qdLimitsFlow />;
	}

	if (limitModal) {
		return <LimitsModal qdLimitsFlow />;
	}

	return limitsResolved ? <QuickDepositMobile {...props} /> : <Spinner />;
};

export default QuickDeposit;
